// extracted by mini-css-extract-plugin
export default {"modal":"DeleteJobsModal-module__modal__teCWN","detail":"DeleteJobsModal-module__detail__jp2w-"};